import axios from '../../../axios';
import ILegalIdentifierSettings from '../types/ILegalIdentifierSettings';
import IUpdateStatus from '../types/IUpdateStatus';

const url = 'invoicingservice/api/';

export const getAllLegalIdentifiersSettings = () => axios.get(`${url}legal-identifier/list`);

export const getAllActiveIdentifiersByWorkspace = () =>
  axios.get(`${url}legal-identifier/list-by-workspaceId`);

export const findLegalIdentifierById = (id: string) => axios.get(`${url}legal-identifier/${id}`);

export const createNewLegalIdentifier = (requestEntity: ILegalIdentifierSettings) =>
  axios.post(`${url}legal-identifier/create-new`, requestEntity);

export const updateLegalIdentifier = (requestEntity: ILegalIdentifierSettings) =>
  axios.put(`${url}legal-identifier/update`, requestEntity);

export const updateLegalIdentifierStatus = (id: string, status: IUpdateStatus) =>
  axios.put(`${url}legal-identifier/update-status/${id}`, status);
